export interface ICorrelationVector {
    /**
     * Get the value of the CV
     * @returns The string representation of the CV. If it exceeds the max allowed
     * length, the value will be truncated and have an ending '!'
     */
    getValue(): string;

    /**
     * Extends the CV to add a new term in the chain.
     */
    extend(): void;

    /**
     * Increments the CV's current chain value by one.
     */
    increment(): void;
}

const base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const baseLength = 16;
const maxLength = 63;

// MeControl CV. Intended to be used throughout the control
// for telemetry and any other similar uses
let cv = createCV();

/** Gets the correlation vector for MeControl */
export function getCv(): ICorrelationVector {
    return cv;
}

/**
 * Sets the correlation vector used throughout MeControl
 * @param newCv Value to use as the new base
 */
export function setCv(newCv: string): void {
    cv = createCV(newCv);
}

/**
 * Define a simple Correlation Vector class for telemetry
 * @param value An optional string to initialize the CV too. Intended use is to
 * have the value be the result of an other instance's getValue(), so as to allow to
 * create a new CV from the string represenation of another.
 */
export function createCV(value?: string): ICorrelationVector {

    // Initialize the CV. If a string value was provided, this
    // becomes the new base value. Otherwise, use a random string
    let _currentValue = 0;
    let _baseValue = value || getRandomBase();

    return {
        getValue(): string {
            let val = _baseValue + '.' + _currentValue;
            if (val.length > maxLength) {
                val = val.substring(0, maxLength) + '!';
            }
            return val;
        },

        extend(): void {
            _baseValue = this.getValue();
            _currentValue = 0;
        },

        increment(): void {
            _currentValue++;
        }
    };
}

/** Create a random base string for CV of the initial base length */
function getRandomBase(): string {
    let str = '';
    while (str.length < baseLength) {
        // Append a random char
        str += base64Chars[Math.floor(Math.random() * base64Chars.length)];
    }
    return str;
}
